export const isLocalhost = window.location.host.includes('localhost:')
export const isPreview = window.location.host.includes('.qa.')

const injected = '__INJECT_ENVIRONMENT__'
const viteEnv = import.meta.env
const env = injected.startsWith('{') ? { ...viteEnv, ...(JSON.parse(injected) as ImportMetaEnv) } : viteEnv

// Log warnings for every env that contains localhost if we are not in localhost
if (isPreview) {
  const keys = Object.keys(env).filter((key) => key.includes('localhost'))
  if (keys.length > 0) {
    console.warn(`Warning: ${keys.length} env variables contain localhost:`, keys)
  }
}

const environment = {
  env: env.VITE_ENV,
  api: env.VITE_API_ENDPOINT,
  healthblocks: {
    integration: env.VITE_INTEGRATION_ENDPOINT,
    integrationSlug: env.VITE_INTEGRATION_SLUG,
    awellIntegrationSlug: env.VITE_AWELL_INTEGRATION_SLUG,
  },
  azure: {
    applicationInsights: {
      connectionString: env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING,
    },
  },
  mixpanel: {
    token: env.VITE_MIXPANEL_TOKEN,
  },
  cookiebot: {
    id: env.VITE_COOKIEBOT_ID,
  },
  care: {
    enrollFormUrl: env.VITE_CARE_PROGRAM_FORM_URL,
    defaultFormRecipient: env.VITE_CARE_PROGRAM_DEFAULT_FORM_RECIPIENT,
  },
  craft: {
    urlMatch: env.VITE_CRAFT_URL_MATCH,
  },
}

/** Legacy environment naming mapped to 3 letter */
export const viteEnvironment =
  environment.env === 'production'
    ? 'prd'
    : environment.env === 'staging'
      ? 'acc'
      : environment.env === 'development'
        ? 'dev'
        : environment.env

export const synopsEndpoint =
  environment.healthblocks.integration || `/integration/${environment.healthblocks.integrationSlug}/endpoint`

export { environment }
